/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Imei_FormatInputs */

const vi_validation_imei_format = /** @type {(inputs: Validation_Imei_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IMEI phải là chuỗi hex 10–16 ký tự (0-9, A-F)`)
};

/**

* @param {Validation_Imei_FormatInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_imei_format = /** @type {((inputs?: Validation_Imei_FormatInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Imei_FormatInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_imei_format(inputs)
});